import { getStore } from '../../store';
import ACTIONS from './actions';
import { TOAST_TYPES } from './toastTypes';

export const showSuccessMessage = message => {
    showMessage(message, TOAST_TYPES.SUCCESS);
};

export const showWarningMessage = message => {
    showMessage(message, TOAST_TYPES.WARNING);
};

export const showInfoMessage = message => {
    showMessage(message, TOAST_TYPES.INFO);
};

export const showLoadingMessage = message => {
    showMessage(message, TOAST_TYPES.LOADING);
};

const showMessage = (toastMessage, toastType) => {
    getStore().dispatch({
        type: ACTIONS.TOAST,
        toastMessage,
        toastType
    });
};

export const clearMessage = () => {
    getStore().dispatch({
        type: ACTIONS.TOAST,
        toastMessage: null,
        toastType: null
    });
};
